// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"Style_loader_container__2c34k","loader":"Style_loader__19WKo","load5":"Style_load5__2T0vT"};